import Permissions from '@/permissions'

export const genderRouters = {
  path: 'gender',
  component: () => import('@/views/settings/gender/Index'),
  redirect: 'gender',
  meta: {
    permissions: [Permissions.backend.setting.gender.manage],
    group: 'gender'
  },
  children: [
    {
      path: '',
      name: 'list-gender',
      component: () => import('@/views/settings/gender/List'),
      meta: {
        permissions: [Permissions.backend.setting.gender.list],
        groups: 'gender',
        breadcrumb: [
          {
            name_en: 'Settings',
            name_km: 'ការកំណត់'
          },
          {
            name_en: 'Gender',
            name_km: 'ភេទ'
          }
        ]
      }
    }
  ]
}
